import { interactiveFaq } from './interactive-faq';
import { smartEscalation } from './smart-escalation';
import { internalLearningAssistant } from './internal-learning-assistant';
import { webEmbedAssistant } from './web-embed-assistant';
import { proactiveProblemSolver } from './proactive-problem-solver';
import { statusPageCommunicator } from './status-page-communicator';

// Export all support playbooks
export const supportPlaybooks = [
  interactiveFaq,
  smartEscalation,
  internalLearningAssistant,
  webEmbedAssistant,
  proactiveProblemSolver,
  statusPageCommunicator,
];

// Export individual playbooks for direct import
export { 
  interactiveFaq, 
  smartEscalation, 
  internalLearningAssistant,
  webEmbedAssistant,
  proactiveProblemSolver,
  statusPageCommunicator
};